import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/TWC.png";

export const theWrestlingClassicDetail = {
  "wrestling-classic": {
    id: "wrestling-classic",
    title: "The Wrestling Classic",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "wrestling-classic",
        items: [
          {
            id: "wrestling-classic-1",
            title: "The Wrestling Classic",
            description: "1985",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
